var module = angular.module('octopusApp.infrastructure');

module.directive("trackUnsavedChanges", function ($rootScope, unsavedChanges) {
  return {
    restrict: 'AC',
    require: "^form",
    link: function (scope, element, attr, ctrl) {
        scope.$watch(function () {
            return ctrl.$dirty;
        }, function () {
            if (ctrl.$dirty) {
                unsavedChanges.unsaved();
            }
        });

        var watchEvent = $rootScope.$on('changesSaved', function () {
            ctrl.$setPristine();
        });

        scope.$on('$destroy', function () {
            watchEvent();
        });
    }
  };
});

module.directive("trackAfter", function ($rootScope, unsavedChanges, octopusLog, $timeout) {
  return {
    restrict: 'AC',
    require: "^form",
    link: function (scope, element, attr, ctrl) {

      $timeout(function() {
        ctrl.$setPristine();
        unsavedChanges.saved();
      }, parseInt(attr.trackAfter, 10));
    }
  };
});

module.directive("unsavedChangesIndicator", function ($rootScope, unsavedChanges) {
  return {
    restrict: 'E',
    template: '<span class="tools-info" ng-show="unsavedChanges.hasUnsavedChanges()">You have unsaved changes</span>',
    link: function (scope, element, attr, ctrl) {
      scope.unsavedChanges = unsavedChanges;
    }
  };
});




//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/track_unsaved_changes.js
// module id = 807917010991744
// module chunks = 1